export const pricingPlans = {
  monthly: [
    {
      id: 'starter',
      name: 'Starter',
      subtitle: 'New Investors',
      price: 19,
      badge: null,
      disabled: false,
      billedText: null,
    },

    {
      id: 'pro',
      name: 'Pro',
      subtitle: 'Active Investors & Wholesalers',
      price: 79,
      badge: 'BEST VALUE',
      disabled: false,
      billedText: null,
    },

    {
      id: 'ultimate',
      name: 'Ultimate',
      subtitle: 'Teams',
      price: null,
      badge: 'COMING SOON',
      disabled: true,
      billedText: null,
    },
  ],

  annual: [
    {
      id: 'starter',
      name: 'Starter',
      subtitle: 'New Investors',
      price: 17,
      badge: null,
      disabled: false,
      billedText: 'Billed $204/yr • Save $24 (10%)',
    },

    {
      id: 'pro',
      name: 'Pro',
      subtitle: 'Active Investors & Wholesalers',
      price: 39,
      badge: 'BEST VALUE',
      disabled: false,
      billedText: 'Billed $468/yr • Save $480 (50%)',
    },

    {
      id: 'ultimate',
      name: 'Ultimate',
      subtitle: 'Teams',
      price: null,
      badge: 'COMING SOON',
      disabled: true,
      billedText: null,
    },
  ],
}